/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Set_Color_RedInputs */



/**
* | output |
* | --- |
* | "Set Color Red" |
*
* @param {Shortcut_Keys_Name_Set_Color_RedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_set_color_red = /** @type {((inputs?: Shortcut_Keys_Name_Set_Color_RedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Set_Color_RedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Set Color Red")
	if (locale === "de") return /** @type {LocalizedString} */ ("Set Color Red")
	if (locale === "it") return /** @type {LocalizedString} */ ("Set Color Red")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Set Color Red")
	if (locale === "es") return /** @type {LocalizedString} */ ("Set Color Red")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Set Color Red")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Set Color Red")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Set Color Red")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Set Color Red")
	return /** @type {LocalizedString} */ ("Set Color Red")
});